var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0547 16.3543L18.6819 14.121V7.92502C18.6819 4.33055 15.6489 1.40625 11.9208 1.40625H11.7031V0H10.2969V1.40625H10.0792C6.35108 1.40625 3.31808 4.33055 3.31808 7.92502V14.1211L0.945312 16.3543V20.6145H7.21128C7.42419 22.5165 9.04212 24 11 24C12.9579 24 14.5758 22.5165 14.7887 20.6145H21.0547V16.3543ZM10.0792 2.8125H11.9208C14.8734 2.8125 17.2756 5.10595 17.2756 7.92502V13.7217H4.72433V7.92502C4.72433 5.10595 7.12653 2.8125 10.0792 2.8125ZM11 22.5938C9.81889 22.5938 8.83377 21.7383 8.63169 20.6145H13.3683C13.1662 21.7383 12.1811 22.5938 11 22.5938ZM19.6484 19.2082H2.35156V16.9619L4.30002 15.128H17.6999L19.6484 16.9619V19.2082Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.7a6a7bc5630c4a9b2c3e5c59aab24819.svg";
export { ForwardRef as ReactComponent };